<template>
    <div style="position: relative;">
        <loading :active.sync="loading" :is-full-page="false"> </loading>
        <div class="table-container">
            <table class="table table-holiday">
                <colgroup>
                    <col width="38%" />
                    <col width="43%" />
                    <col width="10%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Holiday</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="holiday in holidayListPerPage" :key="holiday.holidayDate">
                        <td>{{ holiday.holidayDate | formatHoliday }}</td>
                        <td>{{ holiday.holidayName }}</td>
                        <td><i class="btn-delete" type="button"
                                v-on:click="deleteHoliday(holiday.holidayDate, holiday.holidayName)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- Pagination -->
        <div class="dayoff-pagination">
            <b-pagination class="mb-0" v-model="pageInfo.curr" :total-rows="pageInfo.total" :per-page="pageInfo.perPage">
            </b-pagination>
        </div>
        <div class="dayoff-field-wrap">
            <p class="calendar-sub-title">Add Holiday</p>
            <b-form @submit.prevent ref="form">
                <div class="dayoff-field">
                    <!-- Date -->
                    <b-col>
                        <label for="Holiday">Date</label>
                        <b-input-group class="form-inline date">
                            <b-form-input id="Holiday" name="Holiday" v-validate="{ required: true }" type="text"
                                v-model="holiday.holidayDate" class="custom-input" placeholder="YYYY-MM-DD"
                                size="sm"></b-form-input>
                            <b-input-group-append>
                                <b-form-datepicker id="date-picker" v-model="holiday.holidayDate" button-only
                                    right></b-form-datepicker>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </div>
                <div class="dayoff-field">
                    <b-col>
                        <label for="Name">Holiday</label>
                        <b-input-group class="form-inline">
                            <b-form-input id="Name" name="Name" v-validate="{ required: true }" data-vv-validate-on="change"
                                type="text" v-model="holiday.holidayName" class="custom-input rounded mt-2">
                            </b-form-input>
                        </b-input-group>
                    </b-col>
                </div>
                <b-button class="btn-primary" type="submit"
                    @click="addHoliday()">Add</b-button>
            </b-form>
        </div>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import accessToken from "@/services/accessToken";
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/ko';

export default {
    name: "ChatterHoliday",
    components: { Loading },
    props: ['mainCalendarHolidayList'],
    created() {
        this.retrieveHolidayList();
    },
    watch: {
        'pageInfo.curr'() {
            //pagination의 페이지 증가 및 감소 -> 한 페이지 마다 보여지는 holiday 정보 갱신
            this.holidayListPerPage = this.holidayList.slice((this.pageInfo.curr - 1) * this.pageInfo.perPage, this.pageInfo.curr * this.pageInfo.perPage);
        },
        //mainCalendar.vue의 holidayList 데이터
        mainCalendarHolidayList(data) {
            //holidayList 데이터 갱신
            this.holidayList = data;
            this.pageInfo.total=this.holidayList.length;
            //현재 이동된 페이지 상태 그대로 유지
            this.holidayListPerPage = this.holidayList.slice(this.pageInfo.perPage * (this.pageInfo.curr-1), this.pageInfo.curr * this.pageInfo.perPage);
            //add한 holiday 정보 초기화
            this.holiday.holidayDate = null;
            this.holiday.holidayName = null;
        }
    },
    filters: {
        formatHoliday: function (value) {
            moment.locale('ko');
            return moment(value, 'YYYY-MM-DD').format('YYYY년 MM월 DD일 (dd)');
        }
    },
    data() {
        return {
            loading: false,
            total: 0,
            colorObj: {
                black: 'black',
                goldenRod: 'GoldenRod',
                darkOrange: 'DarkOrange'
            },
            holiday: {
                holidayDate: null,
                holidayName: null,
            },
            cntSeeMore: 0,
            startSerial: 0,
            holidayList: [],
            holidayListPerPage: [],
            pageInfo: {
                curr: 1,
                perPage: 10,
                total: 0,
            },
        }
    },
    methods: {
        async retrieveHolidayList() {
            try {
                this.loading = true;
                const response = await axios.get("chatter/retrieveAllHolidays", {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                });
                this.holidayList = response.data.reverse();
                this.pageInfo.total = this.holidayList.length;
                this.holidayListPerPage = this.holidayList.slice(0, this.pageInfo.perPage);
            } catch (error) {
                this.showError(error);
                this.loading = false;
            } finally {
                this.loading = false;
            }
        },
        // holiday form value 초기화
        resetHoliday() {
            this.holiday.holidayDate = null;
            this.holiday.holidayName = null;
        },
        addHoliday() {
            this.$emit("sendIsHolidayUpdated", this.holiday, true);
        },
        deleteHoliday(holidayDate, holidayName) {
            this.$emit("sendIsHolidayUpdated", { holidayDate: holidayDate, holidayName: holidayName }, false);
        }
    },
}
</script>
<style>
.table td {
    vertical-align: middle;
}
</style>